import React, { useReducer } from "react";

const StoreContext = React.createContext();
const { Provider } = StoreContext;

const storeReducer = (state, action) => {
  switch (action.type) {
    case "ADD_ALL_RECIPES":
      return {
        ...state,
        hasFetched: { ...state.hasFetched, ...{ "recipe:all": true } },
        recipes: [...action.payload]
      };

    case "ADD_RECIPE":
      let recipeId = action.payload.id;
      let rest = state.recipes.filter(resource => resource.id !== recipeId);

      return {
        ...state,
        hasFetched: {
          ...state.hasFetched,
          ...{ [`recipe:${recipeId}`]: true }
        },
        recipes: [...rest, action.payload]
      };

    default:
      throw new Error();
  }
};

const StoreProvider = function({ children }) {
  const initialState = {
    hasFetched: {},
    recipes: []
  };
  const [store, dispatch] = useReducer(storeReducer, initialState);

  return <Provider value={{ store, dispatch }}>{children}</Provider>;
};

export { StoreContext, StoreProvider };
